import { IconBrandWhatsapp } from "@tabler/icons-react";
import {
  FacebookIcon,
  InstagramIcon,
  TwitterIcon,
  YoutubeIcon,
  Moon,
  Sun,
  Computer
} from "lucide-react";

export const FooterApi = [
  {
    id: 1,
    name: "About",
    link: [
      { id: 1, name: "About us", link: "/about" },
      { id: 2, name: "Blogs", link: "/blogs" },
      { id: 3, name: "Send us Feedback", link: "/send-us-feedback" },
      { id: 3, name: "Contact Us", link: "/contact" },
    ],
  },
  {
    id: 2,
    name: "Services",
    link: [
      { id: 1, name: "Phone Repairing", link: "/phone-repairing" },
      { id: 2, name: "Touch Replacement", link: "/touch-replacement" },
      { id: 3, name: "Battery Replacement", link: "/battery-replacement" },
      { id: 4, name: "Combo Replacement", link: "/combo-replacement" },
    ],
  },
  {
    id: 3,
    name: "Categories",
    link: [
      {
        id: 1,
        name: "Mobile Spare Parts",
        link: "/category/mobile-spare-parts",
      },
      {
        id: 2,
        name: "Mobile Accessories",
        link: "/category/mobile-accessories",
      },
      { id: 3, name: "Mobile Combo", link: "/category/mobile-display-screen" },
      { id: 4, name: "Daily use Accessories", link: "/combo-replacement" },
    ],
  },
  {
    id: 4,
    name: "Mobile Spare Parts",
    link: [
      { id: 1, name: "Back Glass", link: "/phone-repairing" },
      { id: 2, name: "Back Panel", link: "/touch-replacement" },
      { id: 3, name: "Battery", link: "/battery-replacement" },
      { id: 4, name: "Combo/Folder", link: "/combo-replacement" },
      { id: 5, name: "Touch Screen", link: "/combo-replacement" },
    ],
  },
  {
    id: 5,
    name: "Privacy & Policy",
    link: [
      { id: 1, name: "Terms & Conditions", link: "/phone-repairing" },
      { id: 2, name: "Privacy Policy", link: "/touch-replacement" },
      { id: 5, name: "Repair Service T&C", link: "/combo-replacement" },
    ],
  },
];

export const FooterApi2 = [
  { id: 1, name: "Guides", link: "" },
  { id: 2, name: "Terms of Sale", link: "" },
  { id: 3, name: "Terms of Use ", link: "" },
  { id: 4, name: "Privacy Policy", link: "" },
];

export const FooterApi3 = [
  {
    id: 1,
    name: "Facebook",
    link: "https://www.facebook.com/devmobilechas/",
    icon: (size: number) => <FacebookIcon size={size} />,
  },
  {
    id: 2,
    name: "Twitter",
    link: "https://www.twitter.com/devmobilechas/",
    icon: (size: number) => <TwitterIcon size={size} />,
  },
  {
    id: 3,
    name: "Youtube",
    link: "https://www.youtube.com/devmobilechas/",
    icon: (size: number) => <YoutubeIcon size={size} />,
  },
  {
    id: 4,
    name: "Facebook",
    link: "https://www.instagram.com/devmobilechas/",
    icon: (size: number) => <InstagramIcon size={size} />,
  },
  {
    id: 5,
    name: "Whatsapp",
    link: "https://wa.me/9334816062",
    icon: (size: number) => <IconBrandWhatsapp size={size} />,
  },
];

interface FooterItem {
  title: string;
  add: [string, string, string][];
}

export const FooterApi4: FooterItem[] = [
  {
    title: "contact us",
    add: [
      [
        "https://maps.app.goo.gl/FakU7c3VPRwZ7Y488",
        "Vaishnavi Heights, Shop no.-5, Bye Pass Road, Chas (827013)",
        "_blank",
      ],
      ["tel: +91 9334816062", "+91 9334816062", ""],
      ["mailto:devmobilechas@shop.in", "devmobilechas@shop.in", ""],
    ],
  },
];

export const ThemeApi = [
  {id:'light', name: 'Light', icon: (size: number) => <Sun size={size} />},
  {id:'dark', name: 'Dark', icon: (size: number) => <Moon size={size} />},
  {id:'system', name: 'System', icon: (size: number) => <Computer size={size} />},
];